import { NumericalColumn, BooleanColumn, StringColumn, CategoricalColumn } from 'baseui/data-table';
import { EMPTY_ARRAY } from 'commons-ui';

export const COL_NAMES = {
	roundNo: 'roundNo',
	tableId: 'tableId',
	score: 'score',
	finalTokenPositions: 'finalTokenPositions',
	tableRank: 'tableRank',
	registeredOn: 'registeredOn',
	joinedOn: 'joinedOn',
	joinType: 'joinType',
	refunded: 'refunded',
	refundedOn: 'refundedOn'
};

export const mttUserGameColumnConfigs = [
	NumericalColumn({
		title: 'Round No',
		mapDataToValue: (data: any) => data[COL_NAMES.roundNo] || 0
	}),
	StringColumn({
		title: 'Table Id',
		mapDataToValue: (data: any) => data[COL_NAMES.tableId]
	}),
	NumericalColumn({
		title: 'Score',
		mapDataToValue: (data: any) => data[COL_NAMES.score] || 0
	}),
	StringColumn({
		title: 'Final Token Positions',
		mapDataToValue: (data: any) => (data[COL_NAMES.finalTokenPositions] || EMPTY_ARRAY).join(',')
	}),
	NumericalColumn({
		title: 'Table Rank',
		mapDataToValue: (data: any) => data[COL_NAMES.tableRank] || 0
	}),
	StringColumn({
		title: 'Registered On',
		mapDataToValue: (data: any) => data[COL_NAMES.registeredOn]
	}),
	StringColumn({
		title: 'Joined On',
		mapDataToValue: (data: any) => data[COL_NAMES.joinedOn]
	}),
	CategoricalColumn({
		title: 'Join Type',
		mapDataToValue: (data: any) => data[COL_NAMES.joinType]
	}),
	BooleanColumn({
		title: 'Refunded',
		mapDataToValue: (data: any) => data[COL_NAMES.refunded]
	}),
	StringColumn({
		title: 'Refunded On',
		mapDataToValue: (data: any) => data[COL_NAMES.refundedOn]
	})
];
